import React from "react";
import {
  RootComponentEditDialogContent,
  RootComponentEditDialogStateProvider,
} from ".";

export const RootComponentEditDialog = () => {
  return (
    <RootComponentEditDialogStateProvider>
      <RootComponentEditDialogContent></RootComponentEditDialogContent>
    </RootComponentEditDialogStateProvider>
  );
};
